"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.location$ = void 0;
var rxjs_1 = require("rxjs");
var operators_1 = require("rxjs/operators");
var window_1 = require("./window");
var patchHistoryMethod = function (method, eventName) {
    var original = history[method];
    history[method] = function (state) {
        var result = original.apply(this, arguments);
        var event = new Event(eventName);
        event.state = state;
        window_1.wnd.dispatchEvent(event);
        return result;
    };
};
if (!!window_1.wnd) {
    patchHistoryMethod('pushState', 'rx-pushstate');
    patchHistoryMethod('replaceState', 'rx-replacestate');
}
var buildState = function (event, location, history) {
    var state = history.state, length = history.length;
    var hash = location.hash, host = location.host, hostname = location.hostname, href = location.href, origin = location.origin, pathname = location.pathname, port = location.port, protocol = location.protocol, search = location.search;
    return {
        event: event,
        state: state,
        length: length,
        hash: hash,
        host: host,
        hostname: hostname,
        href: href,
        origin: origin,
        pathname: pathname,
        port: port,
        protocol: protocol,
        search: search,
    };
};
var createBrowserLocation$ = function () {
    var location$ = new rxjs_1.BehaviorSubject(buildState('load', window_1.wnd.location, window_1.wnd.history));
    (0, rxjs_1.merge)((0, rxjs_1.fromEvent)(window_1.wnd, 'popstate').pipe((0, operators_1.map)(function () { return 'pop'; })), (0, rxjs_1.fromEvent)(window_1.wnd, 'rx-pushstate').pipe((0, operators_1.map)(function () { return 'push'; })), (0, rxjs_1.fromEvent)(window_1.wnd, 'rx-replacestate').pipe((0, operators_1.map)(function () { return 'replace'; })))
        .pipe((0, operators_1.share)(), (0, operators_1.filter)(function () { return window_1.wnd.location.href !== location$.getValue().href; }), (0, operators_1.map)(function (event) { return buildState(event, window_1.wnd.location, window_1.wnd.history); }))
        .subscribe(location$);
    return location$;
};
var createServerLocation$ = function () {
    return new rxjs_1.BehaviorSubject(buildState('load', {
        hash: '',
        host: '',
        hostname: '',
        href: '',
        origin: '',
        pathname: '',
        port: '',
        protocol: '',
        search: '',
    }, {
        length: 0,
        state: null,
    }));
};
exports.location$ = !!window_1.wnd
    ? createBrowserLocation$()
    : createServerLocation$();
